module.exports = __webpack_public_path__ + "static/media/signal.7ebcdb12.svg";